import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { DataService } from '../data.service';
import { NewsletterComponent } from '../newsletter/newsletter.component';
import { GROUPS_CONTACT, OPENING_HOURS, SALES_POINTS } from '@/_config/info.config';

export interface Section {
	id: number;
	name: string;
	order: number;
	footerItem: FooterItem[];
}

interface FooterItem {
	footerSection: number;
	id: number;
	isActive: boolean;
	link: string;
	name: string;
	order: number;
}

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.css'],
	imports: [CommonModule, NewsletterComponent, RouterLink],
	standalone: true,
})
export class FooterComponent implements OnInit, OnDestroy {
	sections: Section[] = [];
	showError = false;
	shouldBeDisplayed = true;

	subscription: Subscription = new Subscription();

	readonly OPENING_HOURS = OPENING_HOURS;
	readonly GROUPS_CONTACT = GROUPS_CONTACT;
	readonly salesPoints = Object.entries(SALES_POINTS).map(([key, value]) => ({ key, value }));
	protected readonly window = inject(DOCUMENT).defaultView;

	constructor(
		private readonly api: DataService,
		@Inject(DOCUMENT) private readonly document: Document,
		private readonly router: Router,
	) {
		this.api.get(
			'www/footer_section/',
			(
				result: {
					next?: number;
					previous?: number;
					results: Section[];
				},
				error: { error: Error },
			) => {
				if (result) {
					this.sections = result.results.map((item) => {
						item.footerItem = item.footerItem
							.filter((v) => v.isActive)
							.sort((a, b) => {
								return a.order - b.order;
							});
						return item;
					});
				} else throw new Error(JSON.stringify(error.error));
			},
		);
	}

	ngOnInit(): void {
		this.subscription = this.router.events.pipe(filter((v) => v instanceof NavigationEnd)).subscribe(() => {
			this.shouldBeDisplayed = !this.document.body.classList.contains('reservation-form');
		});
	}

	ngOnDestroy(): void {
		this.subscription?.unsubscribe();
	}
}
